import { ComponentChildren } from 'preact';
import { getText } from 'src/ConsentManagement/TranslationService';
import { Grid } from '../shared/Grid';
import { ToggleSwitch } from '../shared/UiStates/ToggleSwitch';
import { VendorSelectionType } from './vendorTypes';

type OptionModel = {
  isSelected: boolean;
  vendorOptionType: VendorSelectionType;
  onOptionClicked: (selectionType: VendorSelectionType) => void;
};

type PrivacyDetailModel = {
  uid?: string;
  titleTranslationKey: string;
  translationKey: string;
  detailIds: Array<number>;
  optionModel?: OptionModel;
};

type InfoListItemModel = {
  uid?: string;
  titleTranslationKey?: string;
  children: ComponentChildren;
  optionModel?: OptionModel;
};

export const PrivacyDetail = ({
  uid,
  titleTranslationKey: name,
  translationKey,
  detailIds,
  optionModel,
}: PrivacyDetailModel) => {
  if (detailIds == null || detailIds.length == 0) return null;

  return (
    <InfoListItem titleTranslationKey={name} optionModel={optionModel} uid={uid}>
      <ul class="privacy-detail-list">
        {detailIds.map((id) => (
          <li>{getText(`${translationKey}_name_${id}`)}</li>
        ))}
      </ul>
    </InfoListItem>
  );
};

export const InfoListItem = ({
  titleTranslationKey: titleTranslationKey,
  children,
  uid,
  optionModel,
}: InfoListItemModel) => {
  const onOptionClicked = () => {
    optionModel?.onOptionClicked(optionModel?.vendorOptionType);
  };

  return (
    <section class="cc-accordion-flex">
      <div class="col-info">
        <Grid direction={'vertical'} class="mb-1">
          <strong class="vendor-detail">{getText(titleTranslationKey)}</strong>
          <div class="ml-2">{children}</div>
        </Grid>
      </div>
      {optionModel != null ? (
        <ToggleSwitch
          uid={`vendor-option-${optionModel.vendorOptionType}-${uid}`}
          isChecked={optionModel.isSelected}
          onChangeHandler={onOptionClicked}
        />
      ) : null}
    </section>
  );
};
